
import { handleError } from '@/plugins/helper'
import AuroraBackground from '~/components/common/aurora-background.vue'
import PageBottom from '~/components/common/page-bottom/index.vue'
import TextPressure from '~/components/common/text-pressure.vue'
import FooterNew from '~/components/FooterNew.vue'
import TextPressureMixin from '~/mixins/text-pressure.vue'
import RelatedArticles from '~/sections/vision/ai-workspace/related-articles.vue'
import VisionChildKv from '~/sections/vision/child-kv.vue'
import AiProgram from '~/sections/vision/child-program.vue'
import Initiatives from '~/sections/vision/initiatives.vue'

export default {
  components: {
    TextPressure,
    PageBottom,
    FooterNew,
    AuroraBackground,
    Initiatives,
    VisionChildKv,
    RelatedArticles,
    AiProgram
  },
  mixins: [TextPressureMixin],
  layout: 'home',
  async asyncData({ $content }) {
    const articles = await $content('article/all')
      .limit(4)
      .only(['url', 'thumbnail', 'thumbnailUrl', 'category', 'publicDateStr', 'title', 'media'])
      .fetch()
      .catch(handleError)

    return { articles: Array.isArray(articles) ? articles : [articles] }
  },
  data() {
    return {
      articles: [],
      initiatives: [
        {
          icon: '/images/vision/icon-joystick.svg',
          title: 'ゲーム',
          description:
            'トップクラスの人間プレイヤーの強さに匹敵する対戦AIや、最適なデッキ編成の推薦機能などを提供しています。',
          link: {
            text: '活用事例',
            url: this.$link.articlePage('ゲーム')
          }
        },
        {
          icon: '/images/vision/icon-ball.svg',
          title: 'スポーツ・スマートシティ',
          description:
            '横浜DeNAベイスターズ・川崎ブレイブサンダースといったプロスポーツチームの強化や観戦・購買体験の向上、ワンダリア横浜といったエンタメ施設の体験向上に取り組んでいます。',
          link: {
            text: '活用事例',
            url: this.$link.articlePage('スポーツ・スマートシティ')
          }
        },
        {
          icon: '/images/vision/icon-phone.svg',
          title: 'ライブコミュニティ',
          description:
            'Pococha、IRIAMといったライブ配信サービスにおいて、配信内容やコメントの健全性チェック、リスナーとライバーの最適なマッチング、より良いVtuber体験を実現するための顔認証システム開発などに取り組んでいます。',
          link: {
            text: '活用事例',
            url: this.$link.articlePage('ライブコミュニティ')
          }
        },
        {
          icon: '/images/vision/icon-heart.svg',
          title: 'ヘルスケア',
          description:
            '健康寿命の延伸に向け、エンターテインメント領域で培ったノウハウやインターネット・AIの技術を活かし、健康増進・行動変容を促すサービスやエビデンス創出及びその保健事業への反映などに取り組んでいます。',
          link: {
            text: '活用事例',
            url: this.$link.articlePage('ヘルスケア・メディカル')
          }
        }
      ]
    }
  },
  head() {
    const title = 'Specific AI | VISION'
    const extendMeta = this.$helper.setMetaTitleAndDescription(title)

    return {
      title,
      meta: [...extendMeta]
    }
  }
}
